// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  annotation: "TaskGrid__annotation",
  chip: "TaskGrid__chip",
  chipLarge: "TaskGrid__chipLarge",
  chipMark: "TaskGrid__chipMark",
  chipSmall: "TaskGrid__chipSmall",
  grid: "TaskGrid__grid",
  hint: "TaskGrid__hint",
  hintOn: "TaskGrid__hintOn",
  ink: "TaskGrid__ink",
  legend: "TaskGrid__legend",
  legendItem: "TaskGrid__legendItem",
  markRule: "TaskGrid__markRule",
  off: "TaskGrid__off",
  on: "TaskGrid__on",
  paintable: "TaskGrid__paintable",
  sheetBox: "TaskGrid__sheetBox",
  sizePair: "TaskGrid__sizePair",
  sline: "TaskGrid__sline",
  soff: "TaskGrid__soff",
  wband: "TaskGrid__wband",
  wrap: "TaskGrid__wrap",
  yearLabel: "TaskGrid__yearLabel",
};
